// Generated by scripts/sync-menu-icons.js from sgez_shared/icons/menu/index.json.
export const MENU_ICON_ASSETS = {
  'support.customerWorkQueue': '/icons/menu/customer-work-queue.svg',
  'support.maturityLedger': '/icons/menu/maturity-ledger.svg',
  'support.customers': '/icons/menu/customer-management.svg',
  'support.customerTools': '/icons/menu/customer-tools.svg',
  'support.surveys': '/icons/menu/survey-management.svg',
  'sales.images': '/icons/menu/image-materials.svg',
  'support.kakaoBulk': '/icons/menu/kakao-bulk-send.svg',
  'health.analysis': '/icons/menu/health-analysis.svg',
  'hidden.insurance': '/icons/menu/hidden-insurance.svg',
  'sales.fire': '/icons/menu/fire-insurance.svg',
  'uw3nn.exceptions': '/icons/menu/exception-lookup.svg',
  'requests.list': '/icons/menu/request-management.svg',
  'work.supportTools': '/icons/menu/work-tools.svg',
  'work.insurerSystems': '/icons/menu/insurer-systems.svg',
  'work.insuranceNews': '/icons/menu/insurance-news.svg',
  'work.calendar': '/icons/menu/calendar.svg',
  'work.insurerNewsletters': '/icons/menu/insurer-newsletter.svg',
  'work.education': '/icons/menu/education.svg',
  'sales.publicCard': '/icons/menu/public-card.svg',
  'sales.publicLanding': '/icons/menu/public-landing.svg',
  'sales.orgHomepage': '/icons/menu/org-homepage.svg',
  'sales.consultations': '/icons/menu/consultations.svg',
  'sales.categoryLanding': '/icons/menu/category-landing.svg',
  'people.usersOrDirectory': '/icons/menu/org-users.svg',
  'admin.orgs': '/icons/menu/org-management.svg',
  'admin.orgBanners': '/icons/menu/org-banners.svg',
  'sales.publicPageManage': '/icons/menu/public-page-manage.svg',
  'support.claims': '/icons/menu/claims.svg',
  'home.dashboard': '/icons/menu/dashboard.svg',
  'design.referenceHub': '/icons/menu/design-reference-hub.svg',
  'design.diseaseRider': '/icons/menu/design-disease-rider.svg',
  'design.surgerySearch': '/icons/menu/design-surgery-search.svg',
  'design.majorDiseaseN': '/icons/menu/design-major-disease-n.svg',
  'work.notices': '/icons/menu/notices.svg',
  'work.insurerBusinessHub': '/icons/menu/insurer-business-hub.svg',
  'admin.reports': '/icons/menu/reports.svg',
  'admin.signups': '/icons/menu/signups.svg',
  'admin.withdrawal': '/icons/menu/withdrawal-approvals.svg',
  'admin.availability': '/icons/menu/availability.svg',
  'ops.subscriptionsDashboard': '/icons/menu/subscriptions-dashboard.svg',
  'ops.subscriptionsConfig': '/icons/menu/subscriptions-config.svg',
  'ops.subscriptionsOrgs': '/icons/menu/subscriptions-orgs.svg',
  'ops.subscriptionsHub': '/icons/menu/subscriptions-hub.svg',
  'data.exceptionRules': '/icons/menu/exception-rules.svg',
  'data.insurersMaster': '/icons/menu/insurers-master.svg',
  'data.permissions': '/icons/menu/permissions.svg',
  'data.raw': '/icons/menu/raw-data-management.svg',
  'data.designSupport': '/icons/menu/design-support-reference-data.svg',
  'data.files': '/icons/menu/files.svg',
  'ops.usageDashboard': '/icons/menu/ops-usage-dashboard.svg',
  'ops.systemNotices': '/icons/menu/system-notices.svg',
  'ops.banners': '/icons/menu/ops-banners.svg',
  'ops.supportInquiries': '/icons/menu/support-inquiries.svg',
  'ops.history': '/icons/menu/ops-history.svg',
  'ops.withdrawal': '/icons/menu/ops-withdrawal.svg',
  'ops.claimTemplates': '/icons/menu/ops-claim-templates.svg',
  'ops.claimFax': '/icons/menu/ops-claim-fax.svg',
  'ops.claimStats': '/icons/menu/ops-claim-stats.svg',
  'ops.afterContractCerts': '/icons/menu/after-contract-certificates.svg',
  'ops.orgHomepageTemplates': '/icons/menu/org-homepage-templates.svg',
  'ops.orgHomepageAssets': '/icons/menu/org-homepage-assets.svg',
  'ops.userHomepageTemplates': '/icons/menu/user-homepage-templates.svg',
  'ops.landingTemplates': '/icons/menu/landing-page-templates.svg',
  'ops.surveyTemplates': '/icons/menu/survey-templates.svg',
  'ops.messageTemplates': '/icons/menu/message-templates.svg',
  'ops.alimtalkTemplates': '/icons/menu/alimtalk-templates.svg',
  'ops.alertManagement': '/icons/menu/ops-alert-management.svg',
  'ops.externalVersions': '/icons/menu/external-program-versions.svg',
  'ops.kakaoTalk': '/icons/menu/ops-kakao-talk.svg',
  'ops.legalPolicy': '/icons/menu/legal-policy.svg',
  'ops.supportGuideManuals': '/icons/menu/support-guide-manuals.svg',
  'ops.apiTest': '/icons/menu/api-test.svg',
}

export function getMenuSvgAsset(appIconKey) {
  if (!appIconKey) return null
  return MENU_ICON_ASSETS[appIconKey] || null
}
